import styled from 'styled-components';
import {columnAlignment, tableColSetup} from '../tableSetup/tableSetup';

export const TableHeader = styled.th`
    ${tableColSetup({
        fontWeight: 'var(--table-header-row-text-weight)',
        paddingVert: 'var(--table-header-row-vertical-padding)',
    })};
    z-index: var(z-index-table-header-row);
    white-space: nowrap;

    ${({textAlign}) => columnAlignment(textAlign)};
`;
